import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-3xl flex items-center my-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "block text-base font-normal text-gray-700 mt-2 w-1/2" }, "Parool", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "max-w-3xl flex justify-end my-6 mx-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-500 ease-in-out"
  }, " Salvesta ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Teie viimasest sisselogimisest on palju aega möödas. Turvalisuse huvides palun sisestage vana parool uuesti! ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_ReAuthModal = _resolveComponent("ReAuthModal")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_InputField, {
        class: "w-1/2",
        value: _ctx.password,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
        inputType: _ctx.InputFieldType.PASSWORD,
        "is-autocomplete": false,
        required: "",
        valid: _ctx.passwordValid,
        notValidMessage: 'Parool peab olema vähemalt 6 tähemärki pikk'
      }, null, 8, ["value", "inputType", "valid"]),
      _hoisted_3
    ]),
    (_ctx.reAuthModal)
      ? (_openBlock(), _createBlock(_component_ReAuthModal, {
          key: 0,
          onOnClose: _ctx.onReAuthModalClose
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onOnClose"]))
      : _createCommentVNode("", true)
  ], 32))
}